import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { fadeIn } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

interface LPItemType {
    imgSrc?: string;
    isStart?: boolean;
    homepage?: boolean;
}

export const ActionButtonAnimated = styled(Button, { label: 'ActionButtonAnimated' })`
    animation: ${fadeIn} .5s ease;
`;

type ImageContainerType = Pick<LPItemType, 'imgSrc'>;

export const ImageContainer = styled('div', { label: 'ImageContainer' })<ImageContainerType>`
    ${({ imgSrc }): string => imgSrc === undefined ? '' : `background-image: url(${imgSrc})`};
    background-size: cover;
    height: 168px;
    min-width: 176px;
`;

export const ContentContainer = styled('div', { label: 'ContentContainer' })`
    margin-left: 32px;
    width: 100%;
`;

export const BannerLink = styled('a', { label: 'BannerLink' })`
    color: ${mainColors.default.light};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    margin-left: 6px;
    text-decoration: none;
    &:hover{
        color: ${mainColors.main.secondary};
    }
`;

export const LinkWrapper = styled('div', { label: 'LinkWrapper' })`
    background: ${lpPageColors.indicatorBlue};
    border: 1px solid ${mainColors.main.secondary};
    padding: 20px 0px;
`;

export const BannerWrapper = styled('div', { label: 'BannerWrapper' })`
    background-color: ${lpPageColors.paleGrey};
    border: 1px solid ${lpPageColors.indicatorBlue};
    height: 168px;
    min-width: 176px;
    padding: 52px 15px;
`;

export const CampaignName = styled('div', { label: 'CampaignName' })`
    color: ${mainColors.main.primary};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    padding-bottom: 22px;
`;

export const DatesContainer = styled('div', { label: 'DatesContainer' })`
    display: flex;
`;

type DateWrapperType = Pick<LPItemType, 'isStart'>;

export const DateWrapper = styled('div', { label: 'DateWrapper' })<DateWrapperType>`
    ${({ isStart }): string => isStart === true ? 'margin-right: 16px;' : ''};
`;

export const DateTitle = styled('div', { label: 'DateTitle' })`
    color: ${mainColors.grays.gray400};
    font-size: ${fontSize.small};
    line-height: 1.33;
`;

export const DateValue = styled('div', { label: 'DateValue' })`
    font-size: ${fontSize.xRegular};
    line-height: 1.2;
`;

export const ActionsWrapper = styled('div', { label: 'ActionsWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

// For copy to clipboard functionality
export const TextAreaCopyComponent = styled('textarea', { label: 'TextAreaCopyComponent' })`
    border: 0;
    display: block;
    height: 0;
    margin: 0;
    opacity: 0;
    width: 0;
`;

export const CopyComponentWrapper = styled('div', { label: 'CopyComponentWrapper' })`
    width: 0;
    height: 0;
`;

type IndicatorType = Pick<LPItemType, 'homepage'>;

export const Indicator = styled('div', { label: 'Indicator' })<IndicatorType>`
    background-color: ${({ homepage }): string => homepage === undefined ? lpPageColors.indicatorBlue : lpPageColors.homepageIndicatorBg};
    border-radius: 15px;
    color: ${mainColors.default.light};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-right: 8px;
    padding: 2px 7px;
    text-align: center;
`;

export const IndicatorsWrapper = styled('div', { label: 'IndicatorsWrapper' })`
    display: flex;
    margin: 18px 0 20px 0;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 12px;
`;

export const CopiedMessage = styled('div', { label: 'CopiedMessage' })`
    animation: ${fadeIn} 1.5s ease forwards;
    color: ${lpPageColors.copiedMessage};
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    opacity: 0;
    text-align: center;
    visibility: hidden;
    width: 118px;
`;
